var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"color":_vm.type,"timeout":3000,"bottom":"","left":""},model:{value:(_vm.snacking),callback:function ($$v) {_vm.snacking=$$v},expression:"snacking"}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n  "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){return _vm.$emit('unsnack')}}},[_c('v-icon',[_vm._v("close")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }